module.exports = __webpack_public_path__ + "d2ccce76a3e1ab0d9c210ff6c50352ff.svg";